import * as React from 'react'
import "./loader.scss";
export const Loading: React.FC<{}> = ({}) => {
    return (
        <div className="loader">
            <img alt="" src="loading.svg" />
        </div>
    );
};